<template>
    <div id="logindo">
        <form action="" class="form">
            <p>
                <i class="iconfont paigusu-yonghu"></i> <input type="text" placeholder="用户名" v-model.number.trim="login.phone" :class="{'error-input':error.phone}">
            </p>
            <p>
                <i class="iconfont paigusu-lock"></i> <input type="password" placeholder="密码" v-model="login.password" :class="{'error-input':error.password}">
            </p>


        </form>
        <button class="btn" @click="dologin">登陆</button>

    </div>
</template>

<script>
    export default {
        name: "Logindo",
        data (){
            return {
                cburl : this.$route.query.cburl || '/',
                error:{
                    phone : false,
                    password : false,
                },
                login :{
                    phone : '',
                    password : '',
                }
            }
        },methods : {
            dologin(){
                if(this.login.phone.length < 4){
                    this.error.phone = true;
                    this.$message.error("用户名错误")
                    return;
                }
                this.error.phone = false;

                if(this.login.password.length < 4){
                    this.error.password = true;
                    this.$message.error("密码错误")
                    return;
                }
                this.error.password = false;
                this.axios.post('/api/login/login',{
                    username : this.login.phone,
                    password : this.login.password,
                }).then(r=>{
                    let data = r.data;
                    if(data.code == 0){
                        this.$message.error(data.msg);
                    }else{
                        this.$message.success(data.msg);
                        //存储用户信息
                        this.$store.dispatch('setUserInfo',data.data);
                        this.$router.replace(this.cburl);
                    }
                })
            }
        }
    }
</script>

<style lang="less">
    #logindo{
        .captcha{width: 400px;}
        .captcha-img{position: absolute;right: 0;width: 250px;height: 96px;z-index: 999;}
    }
</style>
